<template>
    <div class="row">
        <div class="col-12 text-center mt-3">
            <h2 class="segment-primary-color" v-if="totalPayments"> {{ currencyFormat(totalPayments) }}</h2>
            <div v-else-if="loading" class="row d-flex font-weight-bolder justify-content-center mt-2">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw mt-4"></i>
            </div>
            <span v-if="hasPayments">VALOR TOTAL DAS {{ payments.length }} PARCELAS FUTURAS</span><br>
            <div class="mt-4">
                <small v-if="hasPayments">Nosso prazo máximo para emissão de boletos é de até 48 horas.</small><br>
                <small v-if="hasPayments">Importante ficar atento ao e-mail cadastrado, o boleto será encaminhado para
                    ele. </small><br>
                <small v-if="hasPayments">Conforme procedimento bancário padrão, a compensação de boletos está prevista
                    para ocorrer em até 72
                    horas úteis. </small>
            </div>
            <div class="mt-4 mb-2" v-if="showDiscount">
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <h3>{{ currencyFormat(modalAntecipate.discountValue) }}</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <h3 style="color: #0b98de;">{{ currencyFormat(modalAntecipate.discount) }}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6"><small>Valor a pagar</small></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6"><small style="color: #0b98de;">Desconto</small></div>
                </div>
            </div>
            <div v-if="showDiscount" class="mt-4 d-flex justify-content-center">
                <button type="button" @click="openModal"
                    class="btn custom-btn bg-segment-primary-color text-center justify-content-center"
                    :disabled="loadingButton">Quero antecipar <i v-if="loadingButton"
                        class="fa fa-spinner fa-pulse fa-fw"></i></button>
            </div>
            <div v-if="temSegundaVia" class="mt-3 mx-4 p-3" style="background-color: rgba(255, 152, 0, 0.15); border-radius: 10px;">
                <span class="font-weight-bold" style="color: rgba(180, 100, 0, 1); font-size: 13px;">
                    Você possui uma segunda via em aberto. Selecione-a abaixo para copiar o código ou receber por e-mail.
                </span>
            </div>
            <div v-if="selectedSegundaVia" class="mt-3">
                <div class="mb-2">
                    <h3 class="segment-primary-color">{{ currencyFormat(selectedSegundaVia.valorcorrigido) }}</h3>
                    <small>Parcela {{ selectedSegundaVia.par_in_codigo }} - Vencimento {{ formatDate(selectedSegundaVia.par_dt_vencimento) }}</small>
                </div>
                <div class="d-flex justify-content-center gap-2 flex-wrap">
                    <button v-if="selectedSegundaVia.barcode" type="button" @click="copyBarcode"
                        class="btn custom-btn bg-segment-primary-color">
                        <i class="fas fa-copy me-1"></i> Copiar Código
                    </button>
                    <button type="button" @click="modalSegundaViaEmail = true"
                        class="btn btn-outline-primary">
                        <i class="fas fa-envelope me-1"></i> Receber por E-mail
                    </button>
                </div>
            </div>
            <div class="mt-4">
                <span v-if="hasPayments" style="font-size: 14px;">Selecione parcelas para antecipar</span>
            </div>
            <div v-if="!loading && !hasPayments" class="mb-4">
                <span class="segment-primary-color font-weight-bolder mb-4" style="font-size: 15px;">SEM PARCELAS
                    FUTURAS</span>
            </div>
        </div>
        <div v-if="hasPayments" class="mt-2 d-flex justify-content-center mb-2 ms-2">
            <table class="table align-items-center mb-0">
                <thead>
                    <tr class="mb-2 ms-2">
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Parcela
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Valor</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Vencimento
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="payment in payments" :key="payment.par_in_codigo">
                        <td>
                            <div class="d-flex px-2 py-1">
                                <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-xs">{{ payment.par_in_codigo }}</h6>
                                    <p class="text-xs text-secondary mb-0">{{ getSituation(payment.situacao_parcela) }}
                                    </p>
                                    <span v-if="isSegundaVia(payment)" class="text-xs font-weight-bold" style="color: #E5A100;">
                                        Segunda via (parcela em atraso)
                                    </span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="text-xs font-weight-bold mb-0">{{ currencyFormat(payment.valorcorrigido)
                            }}</span>
                        </td>
                        <td>
                            <p class="text-xs font-weight-bold mb-0">{{ formatDate(payment.par_dt_vencimento) }}</p>
                        </td>
                        <td>
                            <div v-if="payment.situacao_parcela == 'A_PAGAR'" class="form-check my-auto ms-auto">
                                <input :id="payment.par_in_codigo" class="form-check-input" type="checkbox"
                                    style="width: 30px;height: 30px;"
                                    :disabled="selectedSegundaVia != null"
                                    @change="toggleSelection(payment.par_in_codigo)" />
                            </div>
                            <div v-if="isSegundaVia(payment)" class="form-check my-auto ms-auto">
                                <input :id="'sv_' + payment.par_in_codigo" class="form-check-input" type="checkbox"
                                    style="width: 30px;height: 30px;"
                                    :checked="selectedSegundaVia?.par_in_codigo === payment.par_in_codigo"
                                    :disabled="selectedPayments.length > 0"
                                    @change="selectSegundaVia(payment)" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <Dialog v-model:visible="visible" modal header="Antecipar Parcelas" :style="{ width: '25rem' }">
        <div class="row mb-2">
            <div class="col-12 text-center">
                <h2>{{ currencyFormat(modalAntecipate.totalValue) }}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex justify-content-start">Valor</div>
            <div class="col-6 d-flex justify-content-end">{{ currencyFormat(modalAntecipate.discountValue) }}</div>
        </div>
        <div class="row">
            <div class="col-6 d-flex justify-content-start">Desconto</div>
            <div class="col-6 d-flex justify-content-end">{{ currencyFormat(modalAntecipate.discount) }}</div>
        </div>
        <div class="mt-4 row">
            <label>Data de pagamento</label>
            <argon-input type="text" placeholder="" v-model="paymentDate" v-maska="'##/##/####'" />
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Valor a pagar</label>
            <argon-input type="text" placeholder="" v-model="antecipateValue" v-money="money" />
        </div>
        <div class="mt-4 col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Enviar boleto para</label>
            <InputText type="text" class="w-100" placeholder="" v-model="userMail" disabled />
        </div>

        <div v-if="newSimulateDiscount" class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingButton" type="button" @click="newSimulate()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Simular antecipação <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
        <div v-if="!newSimulateDiscount && confirmSolicitation" class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingButton" type="button" @click="sendAdvance()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Confirmar Solicitação <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>
    <Dialog v-model:visible="modalSegundaViaEmail" modal header="Receber Segunda Via por E-mail" :style="{ width: '25rem' }">
        <div class="mt-2">
            <label>Enviar boleto para</label>
            <InputText type="text" class="w-100" v-model="userMail" disabled />
        </div>
        <div class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingSegundaVia" type="button" @click="sendSegundaViaEmail()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Confirmar <i v-if="loadingSegundaVia" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import moment from 'moment';
import axios from 'axios';
import { useStore } from 'vuex';
import Dialog from 'primevue/dialog';
import ArgonInput from '@/components/ArgonInput.vue';
import InputText from 'primevue/inputtext';
import { showToast } from '@/assets/js/toast.js';
import { VMoney } from 'v-money';

const money = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false
};

const previousPaymentDate = ref('');
const previousAntecipateValue = ref('');
const loading = ref(true);
const loadingButton = ref(false);
const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);
const payments = ref([]);
const totalPayments = ref(0);
const selectedPayments = ref([]);
const visible = ref(false);
const newSimulateDiscount = ref(true)
const confirmSolicitation = ref(false)
const showDiscount = ref(false)
const paymentDate = ref();
const today = ref(moment().add(1, 'days').format('DD/MM/YYYY'));
const antecipateValue = ref('');
const modalAntecipate = ref({
    totalValue: null,
    discountValue: null,
    discount: null,
    parcels: null
});
const userMail = store.getters.getCurrentUser ? store.getters.getCurrentUser.email : null;

const hasPayments = computed(() => payments.value && payments.value.length > 0);
const selectedSegundaVia = ref(null);
const modalSegundaViaEmail = ref(false);
const loadingSegundaVia = ref(false);
const temSegundaVia = computed(() => payments.value.some(p => p.situacao_parcela === 'EM_ABERTO' && p.par_atrasada === 'SIM'));

const isSegundaVia = (payment) => payment.situacao_parcela === 'EM_ABERTO' && payment.par_atrasada === 'SIM';

const selectSegundaVia = (payment) => {
    if (selectedSegundaVia.value?.par_in_codigo === payment.par_in_codigo) {
        selectedSegundaVia.value = null;
    } else {
        selectedSegundaVia.value = payment;
    }
};

const copyBarcode = async () => {
    if (selectedSegundaVia.value?.barcode) {
        await navigator.clipboard.writeText(selectedSegundaVia.value.barcode);
        showToast('Código copiado para a área de transferência.', 'success');
    }
};

const sendSegundaViaEmail = async () => {
    try {
        loadingSegundaVia.value = true;
        const data = {
            parcel: [selectedSegundaVia.value.par_in_codigo],
            email: userMail,
            data_solicitacao: moment().format('DD/MM/YYYY'),
            notificacao: true
        };
        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/duplicate`, data);
        if (response.data) {
            showToast('Boleto enviado para o e-mail cadastrado.', 'success');
            modalSegundaViaEmail.value = false;
        }
    } catch (error) {
        showToast('Erro ao enviar boleto por e-mail.', 'error');
    } finally {
        loadingSegundaVia.value = false;
    }
};

const isInitialLoad = ref(true);

onMounted(async () => {
    getPayments();
    // getNextPayments();
    // getOpenPayments();
    paymentDate.value = getNextBusinessDay(today.value);
});

// const getNextPayments = async () => {
//     try {
//         const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=A_PAGAR`);
//         payments.value = response.data;
//         sumTotalNextPayments();
//         loading.value = false;
//     } catch (error) {
//         console.error(error);
//     }
// };

// const getOpenPayments = async () => {
//     try {
//         const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=EM_ABERTO`);
//         payments.value = response.data;
//         sumTotalNextPayments();
//         loading.value = false;
//     } catch (error) {
//         console.error(error);
//     }
// };

const getPayments = async () => {
    try {
        // Executa as duas requisições em paralelo
        const [openPaymentsResponse, nextPaymentsResponse] = await Promise.all([
            axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=EM_ABERTO`),
            axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=A_PAGAR`),
        ]);

        // Mescla os dados das duas respostas
        payments.value = [...openPaymentsResponse.data, ...nextPaymentsResponse.data];

        // Calcula o total
        sumTotalNextPayments();
        loading.value = false;
    } catch (error) {
        console.error(error);
    }
}

const getSituation = (situation) => {
    switch (situation) {
        case 'EM_ABERTO':
            return 'VIGENTE'
        case 'A_PAGAR':
            return 'FUTURA'
    }
}

const newValues = () => {
    newSimulateDiscount.value = true;
    confirmSolicitation.value = false;
}

const newSimulate = () => {
    const data = {
        parcel: modalAntecipate.value.parcels,
        send_mail: false,
        email: 'simulate-test@simulate-test.com.br',
        notificacao: false,
        effect: false,
        antecipate_date: paymentDate.value,
        valor_pagar: antecipateValue.value
    }
    console.log(data)
    simulateDiscount(data)
}

const toggleSelection = (paymentId) => {
    const index = selectedPayments.value.indexOf(paymentId);
    if (index === -1) {
        selectedPayments.value.push(paymentId);
    } else {
        selectedPayments.value.splice(index, 1);
    }

    if (selectedPayments.value.length === 0) {
        showDiscount.value = false;
        return;
    }

    const stringParcels = selectedPayments.value.join(',');

    const data = {
        parcel: stringParcels,
        send_mail: false,
        email: 'simulate-test@simulate-test.com.br',
        notificacao: false,
        effect: false,
        antecipate_date: getNextBusinessDay(today.value)
    }
    simulateDiscount(data)
};

const sendAdvance = async () => {
    const data = {
        parcel: modalAntecipate.value.parcels,
        send_mail: false,
        email: userMail,
        notificacao: false,
        effect: true,
        antecipate_date: paymentDate.value,
        valor_pagar: antecipateValue.value
    }
    console.log(data)
    try {
        loadingButton.value = true
        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/antecipate-bill-installments-parcels`, data);
        if (response.data.result.ERRO) {
            showToast(response.data.result.DESCRICAO, 'error');
        } else {
            showToast('Solicitação de adiantamento de parcela enviada com sucesso.', 'success');
            visible.value = false
        }
    } catch (error) {
        showToast('Não foi possivel complatar a solicitação', 'error');
        console.error(error);
    } finally {
        loadingButton.value = false
    }
}

const simulateDiscount = async (data) => {
    console.log(data)
    try {
        loadingButton.value = true
        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/antecipate-bill-installments-parcels`, data);
        console.log(response.data.result)

        if (response.data.result.ERRO) {
            showToast(response.data.result.DESCRICAO, 'error');
        } else {
            modalAntecipate.value.totalValue = response.data.result.VALOR_TOTAL
            antecipateValue.value = currencyFormat(response.data.result.VALOR_TOTAL)
            modalAntecipate.value.discountValue = response.data.result.VALOR_ANTECIPADO
            modalAntecipate.value.discount = response.data.result.VALOR_DESCONTO
            modalAntecipate.value.parcels = data.parcel
            isInitialLoad.value = true;
            newSimulateDiscount.value = false;
            confirmSolicitation.value = true;
        }
    } catch (error) {
        console.error(error);
    } finally {
        loadingButton.value = false
        if (selectedPayments.value.length > 0) {
            newSimulateDiscount.value = false;
            confirmSolicitation.value = true;
            showDiscount.value = true;
        } else {
            showDiscount.value = false;
        }
    }
}

const openModal = () => {
    isInitialLoad.value = true;
    visible.value = true
}

const currencyFormat = (value, currency = false) => {
    const options = {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    const formattedValue = new Intl.NumberFormat('pt-BR', options).format(value);

    if (currency) {
        return `${formattedValue}`;
    }

    return formattedValue;
};

const isBusinessDay = (date) => {
    const dayOfWeek = date.day();
    // Dias úteis são de segunda a sexta-feira (1 = segunda-feira, 5 = sexta-feira)
    return dayOfWeek >= 1 && dayOfWeek <= 5;
};

// Função para obter o próximo dia útil
const getNextBusinessDay = (today) => {
    const startDate = moment(today, 'DD/MM/YYYY');

    // Adiciona um dia até encontrar um dia útil
    let date = startDate.clone();
    while (!isBusinessDay(date)) {
        console.log('sadasd')
        date.add(1, 'days');
        // Se a data resultante for um sábado ou domingo, continua o loop
        if (date.day() === 6) {
            date.add(2, 'days'); // Salta para segunda-feira
        }
    }

    return date.format('DD/MM/YYYY');
};
const sumTotalNextPayments = () => {
    totalPayments.value = payments.value.reduce((acc, payment) => acc + parseFloat(payment.valorcorrigido), 0);
};

const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
};

// Observadores para detectar mudanças nos valores
watch(paymentDate, (newValue) => {
    if (!isInitialLoad.value && newValue !== previousPaymentDate.value) {
        newValues();
        previousPaymentDate.value = newValue;
    }
    isInitialLoad.value = false; // Após o primeiro carregamento, atualiza a flag
});

watch(antecipateValue, (newValue) => {
    if (!isInitialLoad.value && newValue !== previousAntecipateValue.value) {
        newValues();
        previousAntecipateValue.value = newValue;
    }
    isInitialLoad.value = false; // Após o primeiro carregamento, atualiza a flag
});

</script>
<style>
.bg-color {
    background-color: #ededed !important;
}
</style>
